import TicketTypesSummary from './TicketTypesSummary';

export default TicketTypesSummary;
